exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar[data-v-52554352]{min-width:16rem;margin-right:3rem;padding-right:.5rem;position:-webkit-sticky;position:sticky;top:1rem;overflow:auto;max-height:calc(100vh - 2rem)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52554352","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Sidebar.vue
// module id = 214
// module chunks = 58